export default class Sas {
    constructor(props, events) {
        this.props = props || {}
        this.events = events || {}
    }

    get getProps() {
        return this.props
    }

    get getEvents() {
        return this.events
    }
}